import { Grid, TextareaAutosize, Typography } from "@mui/material";
import {
  CommonButton,
  CustomCheckbox,
  CustomInputLabel,
  CustomRequiredInputLabel,
  CustomTextFeild,
} from "../../common/StyledComponents/StyledFields";
import styles from "../contactus.module.scss";
import commonstyles from "../../../App.module.scss";
import { useState } from "react";
import { ValidationError, object, string } from "yup";
import {
  apiRequest,
  catchErrorMessageHandler,
  getUserName,
} from "../../../infrastructure/backendService";
import apiPath from "../../../config/apiPaths.json";
import toast, { Toaster } from "react-hot-toast";
import ToastError from "../../common/toast/toastError";
import { isNil } from "lodash";
import ToastSuccess from "../../common/toast/toastSuccess";
import LOCALE from '../../../config/en-us.json';
import ReCAPTCHA from "react-google-recaptcha";
import SuccessPopup from "../../devotee/donation/successPopup";
import ErrorPopup from "../../common/ErrorPopup";
import constants from "../../../config/constants.json"

type ErrorMessageTypes = {
  fromEmail: string;
  message: string;
  subject: string;
};
interface SendEmailProps {
  handleClose: () => void;
  toEmail: string;
  selectedName: string;
  commiteeName: string;
}
const SendEmail = (props: SendEmailProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
    fromEmail: "",
    subject: "",
    message: "",
  });
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const validationSchema = object().shape({
    fromEmail: string().required("From is required"),
    message: string().required("Message is required"),
    subject: string().required("Subject is required"),
  });
  const [formData, setFormData] = useState({
    fromEmail: "",
    subject: "",
    message: "",
    bcc: "",
    cc: "",
  });
  const [selectedName, setSelectedName] = useState<string>("");
  const [toEmail, setToEmail] = useState<string>("");

  const sendApiCall = () => {
    const reqBody = {
      fromEmail: formData.fromEmail,
      userName: getUserName(),
      toEmail: props.toEmail,
      toName: props.selectedName,
      cc: formData.cc,
      bcc: formData.bcc,
      subject: formData.subject,
      message: formData.message,
    };
    apiRequest({
      method: "POST",
      endpoint: apiPath.sendMailToContactInfo,
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        console.log(res);
        setSelectedName("");
        setToEmail("");
        const successMessage = LOCALE.EMAIL_SEND;
        // toast.custom(<ToastSuccess message={successMessage} sent={""} />, {
        //   duration: 10000,
        // });
        toast.custom(<SuccessPopup headerMessage="Email" showMessage={successMessage} isOpen={isOpen} setIsOpen={setIsOpen} />,
        {
          duration: constants.TOAST_POPUP_DURATION,
        });
      })
      .catch((err) => {
        console.log(err);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  };

  const handleSave = async (): Promise<void> => {
    const errors: ErrorMessageTypes = {
      fromEmail: "",
      subject: "",
      message: "",
    };

    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);
      // Call your API or perform other actions here
      sendApiCall();
    } catch (error: any) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e: any) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
  };
  const handleFieldChange = (field: string, value: any) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };
  const handleback = () => {
    props.handleClose();
  };

  const handleCaptchaVerify = (response: any) => {
    // Handle the verification result, you might want to send this to your server.
    console.log("Captcha Response:", response);
    setIsCaptchaVerified(true);
  };

  const handleButtons = () => {
    return (
      <div style={{ margin: "30px" }}>
        <CommonButton className={commonstyles.saveButton} onClick={handleSave}>
          Submit
        </CommonButton>
        <button
          className={styles.cancelButton}
          style={{ marginLeft: "5px" }}
          onClick={handleback}
        >
          Close
        </button>
      </div>
    );
  };
  return (
    <>
      <div>
        <div>
          <div className={styles.sendemailContainer}>
            <Grid
              container
              spacing={1}
              sx={{ padding: "25px" }}
              className={styles.formContainer}
            >
              <Grid container spacing={2}>
                <Grid xs={12} sm={5} item>
                  {CustomRequiredInputLabel("From", true)}
                  <CustomTextFeild
                    className={
                      errorMessage.fromEmail
                        ? styles.errorTextField
                        : styles.textField
                    }
                    value={formData.fromEmail}
                    fullWidth
                    required
                    onChange={(e) => {
                      handleFieldChange("fromEmail", e.target.value);
                      setErrorMessage({ ...errorMessage, fromEmail: "" });
                    }}
                    placeholder="Enter From Email"
                  />
                  {errorMessage.fromEmail ? (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                      {errorMessage.fromEmail}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid xs={12} sm={5} item>
                  <CustomInputLabel>To :</CustomInputLabel>
                  {props.selectedName} ({props.commiteeName})
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid xs={12} sm={5} item className={styles.singleFeild}>
                  <CustomInputLabel>CC</CustomInputLabel>
                  <CustomTextFeild
                    className={styles.textField}
                    value={formData.cc}
                    fullWidth
                    required
                    onChange={(e) => {
                      handleFieldChange("cc", e.target.value);
                    }}
                    placeholder="Enter Cc"
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid xs={12} sm={5} item className={styles.singleFeild}>
                  <CustomInputLabel>BCC</CustomInputLabel>
                  <CustomTextFeild
                    className={styles.textField}
                    value={formData.bcc}
                    fullWidth
                    required
                    onChange={(e) => {
                      handleFieldChange("bcc", e.target.value);
                    }}
                    placeholder="Enter Bcc"
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid xs={12} sm={5} item className={styles.singleFeild}>
                  {CustomRequiredInputLabel("Subject", true)}
                  <CustomTextFeild
                    className={
                      errorMessage.subject
                        ? styles.errorTextField
                        : styles.textField
                    }
                    value={formData.subject}
                    fullWidth
                    required
                    onChange={(e) => {
                      handleFieldChange("subject", e.target.value);
                      setErrorMessage({ ...errorMessage, subject: "" });
                    }}
                    placeholder="Enter Subject"
                  />
                  {errorMessage.subject ? (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                      {errorMessage.subject}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid xs={12} sm={5} item className={styles.singleFeild}>
                  {CustomRequiredInputLabel("Message", true)}
                  <TextareaAutosize
                    style={{
                      height: "89px",
                      width: "678px",
                      backgroundColor: "#fff9e4",
                      borderRadius: "8px",
                    }}
                    className={
                      errorMessage.message
                        ? styles.errorTextField
                        : styles.textField
                    }
                    value={formData.message}
                    onChange={(e) => {
                      handleFieldChange("message", e.target.value);
                      setErrorMessage({ ...errorMessage, message: "" });
                    }}
                  />
                </Grid>
              </Grid>
              {errorMessage.message ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {errorMessage.message}
                </Typography>
              ) : (
                ""
              )}
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={12}
                  sm={2}
                  sx={{ display: 'flex', alignItems: 'center', marginTop: "25px" }}
                >
                  {/* <CustomCheckbox />
                  <Typography className={styles.checkboxtext}>
                    iam not a robot
                  </Typography> */}
                  <ReCAPTCHA
                    sitekey="6LfU7-QUAAAAAICECh7JUCI-gEC9cZ-kAxJviFCR"
                    onChange={handleCaptchaVerify}
                  />
                  {/* <img
                    src="/images/captcha.png"
                    style={{ width: "32px", height: "32px" }}
                  /> */}
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <div style={{ display: "flex", float: "left", top: "300px" }}>
                  {handleButtons()}
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </>
  );
};
export default SendEmail;
